import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

//import CardFront from '../imgs/covers/staging1.jpg'
import CardFront from '../imgs/covers/staging2.jpg'
import CardBack from '../imgs/covers/staging2.jpg'

const styles = theme => ({
    container: {
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
        width: '100%'
    },
    title: {
        marginBottom: 30,
        color: '#393287'
    },
    p: {
        marginTop: 20,
        color: '#393287',
        fontSize: 16
    },
    p2: {
        marginTop: 0,
        color: '#393287'
    },
    ul: {
        marginBlockStart: 0
    },
    details: {
        paddingLeft: 10
    }
})

class Home extends React.Component{
    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid item md={4} sm={12}>
                    <Typography variant="title" className={classes.p}>
                        Real Estate Staging
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        Purpleleaf Design offers many services to improve the appearance and attractiveness of your home, whether for you, a buyer or renter. In addition to staging vacant and owner-occupied homes, we also offer home staging consultations, quick staging for photo shoots, open house preparation, and the staging and marketing of rental properties.
                    </Typography>

                    <Typography variant="title" className={classes.p}>
                        Consultation
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        The purpose of this meeting is to review what’s needed for your home to successfully move on the market. We will start at the curb, continue through your home room by room, and then venture out to the backyard. After the consultation, we will provide you with a comprehensive checklist of “things to do” in order to make your home the most marketable in the area. Should you desire, we can assist you with some of the checklist items, or refer you to our approved contractors, painters, cleaners, etc.
                    </Typography>

                    <Typography variant="title" className={classes.p}>
                        Open House Staging
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        Arriving on the day of your open house, we will help you set the stage for a successful showing. Last-minute touches and a bit of finesse can make all the difference.
                    </Typography>

                    <Typography variant="title" className={classes.p}>
                        We can help with:
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        <ul className={classes.ul}>
                            <li>Interior Design</li>
                            <li>Funiture Rental</li>
                            <li>Photography</li>
                            <li>Virtual Tour</li>
                            <li>3D Walkthrough</li>
                            <li>Customized Web site</li>
                            <li>Target Social Media: Wechat, Facebook</li>
                            <li>Flyer Design and Print</li>
                        </ul>
                    </Typography>
                </Grid>
                <Grid item md={8} sm={12} className={classes.details}>
                    <img src={CardFront} className={classes.img}/>
                    {/* <img src={CardBack} className={classes.img}/> */}
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)